import React, { useEffect } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner';

const Login                 = React.lazy(() => import('./Components/Login/Login'))
const Dashboard             = React.lazy(() => import('./Components/Dashboard/Dashboard'))
const Header                = React.lazy(() => import('./Components/Header/Header'))
const Footer                = React.lazy(() => import('./Components/Footer/Footer'))
const History               = React.lazy(() => import('./Components/History/History'))
const Strategy              = React.lazy(() => import('./Components/Strategy/Strategy'))
const CreateStrategy        = React.lazy(() => import('./Components/Strategy/CreateStrategy'))
const UpdateStrategy        = React.lazy(() => import('./Components/Strategy/UpdateStrategy'))
const Slot                  = React.lazy(() => import('./Components/Slot/Slot'))
const Pair                  = React.lazy(() => import("./Components/Pair/Pair"))
const Keys                  = React.lazy(() => import("./Components/Keys/Keys"))
const ScrollToTop           = React.lazy(() => import("./Components/OtherComponents/ScrollToTop"))

function App() {

    useEffect(()=>{
        const theme = localStorage.getItem('layout_theme')
        if(theme) {
            const currentTheme = (theme === 'dark')
            if(!currentTheme) {
                document.querySelector('body')?.classList.remove('dark')
            }else {
                document.querySelector('body')?.classList.add('dark')
            }
        }else {
            localStorage.setItem('layout_theme', "dark")
            document.querySelector('body')?.classList.add('dark')
        }
    },[])



    return (
        <>
            <Toaster visibleToasts={1} richColors={true} position="top-right" duration={3000} />
            <div className="w-full h-auto bg-bgLight text-dark dark:bg-bgDark dark:text-white text-black">
                <React.Suspense fallback={<FallbackLoader />}>
                    <Routes>
                        <Route element={<Auth />}>
                        <Route path='*' element={<Navigate to={'/'}/>}/>
                            <Route index path='/' element={<Login />} />
                        </Route>
                        <Route element={<ProtectedAuth />}>
                        <Route path='*' element={<Navigate to={'/dashboard'}/>}/>
                            <Route path={'/dashboard'} element={<Dashboard />}/>
                            <Route path={'/strategy'} element={<Strategy />}/>
                            <Route path={'/slots'} element={<Slot />}/>
                            <Route path={'/slots/:activeSlot'} element={<Slot />}/>
                            <Route path={'/createStrategy'} element={<CreateStrategy />}/>
                            <Route path={'/updateStrategy/:id'} element={<UpdateStrategy />}/>
                            <Route path={'/history/:historyType'} element={<History />}/>
                            <Route path={'/pairList'} element={<Pair />}/>
                            <Route path={'/keys'} element={<Keys />}/>
                        </Route>
                    </Routes>
                </React.Suspense>
            </div>
        </>
    );
}

export default App;

const Auth = () => {
    const isLogin = localStorage.getItem('UWEHSDDIJFD') || ''

    return (
        !isLogin ? <Outlet /> : <Navigate to={'/dashboard'}/> 
    )
}

const ProtectedAuth = () => {
    const isLogin = localStorage.getItem('UWEHSDDIJFD') || ''

    return (
        isLogin ? 
        <>
            <div className='transition-all delay-100 min-h-screen text-black dark:text-white'>
                <Header />
                <div className='m-2 pb-[65px] pt-[5px]'>
                    <Outlet /> 
                </div>
                <Footer />
            </div>
            <ScrollToTop />
        </>
        : <Navigate to={'/'}/>
    )
}

const FallbackLoader = () =>  {
    return(
        <div className='flex items-center justify-center w-full h-screen bg-[#383d52]'>
            <h1 className='text-[100px] text-gray font-bold text-white loader-txt'>BITFX</h1>
        </div>
    )
}